import { customAxios, IDUSUARIO, PROFORMA_URL } from '../constants';

export function guardarMaestro(codGrupo, codGrupoRec, codTipo, codTipoRec, descripcion, indInactivo, observacion, ordenPres, valorAdicional1, valorAdicional2) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    codGrupo, codGrupoRec, codTipo, codTipoRec, descripcion, indInactivo, observacion, ordenPres, valorAdicional1, valorAdicional2
  };

  return customAxios.post(`${PROFORMA_URL}/mantenimiento/tablaMaestro/guardarTablaMaestro`, data, config);
}


// WEBPACK FOOTER //
// ./src/utils/mantenimientoMaestro.js